import api from './data.services'
import {authService} from "./auth.service";

const surveyRegister = 'survey'

const registerSurvey = async (surveyData: any ) => {
  try {
    const resp: any = await api.post(surveyRegister, surveyData, authService.getToken())

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error: any) {
    return {
      status: 'Error',
      statusCode: error?.statusCode,
      error,
      message: (error && error.statusCode === 400 ? error?.errors[0]?.msg : 'Error server al registrar sugerencia!')
    }
  }
}

export const survey = {
  registerSurvey
}
